function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.718,
    height: 44.835,
    viewBox: "0 0 42.718 44.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10128",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Home"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Home",
    d: "M14.044 39.739v-6.473a3 3 0 0 1 3.014-2.992h6.084a3.025 3.025 0 0 1 2.131.876 2.981 2.981 0 0 1 .883 2.115v6.472a2.568 2.568 0 0 0 .754 1.835 2.606 2.606 0 0 0 1.843.762H32.9a7.324 7.324 0 0 0 5.172-2.115 7.217 7.217 0 0 0 2.144-5.129V16.652a5.234 5.234 0 0 0-1.9-4.026L24.2 1.431a6.556 6.556 0 0 0-8.358.151L2.047 12.626A5.237 5.237 0 0 0 0 16.652v18.42a7.289 7.289 0 0 0 7.316 7.263h4.056a2.606 2.606 0 0 0 2.616-2.578z",
    style: {
      fill: "none",
      stroke: "#727272",
      strokeWidth: "2.5px"
    },
    transform: "translate(1.25 1.251)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.88125546.svg";
export { ForwardRef as ReactComponent };